import { type ServiceMethod } from '@/application/interfaces/service';

export type PostalCode = {
  description?: string | null;
  number: string;
  type: string;
};

type Body = {
  city: string;
  state: string;
  district: string;
  street: string;
  number: string;
  complement?: string;
  reference?: string;
  ibgeCityCode: string;
  postalCode: PostalCode;
};

type Params = {
  cartId: string;
};

export type Data = Params & Body;

export type Response = {
  data: {
    success: boolean;
  };
};

const postCartAddress: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const { cartId, ...bodyData } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/carts/{cartId}/address',
      {
        ...options,
        body: bodyData,
        params: {
          cartId,
        },
      }
    );

    return response;
  };

export default postCartAddress;
